import React, { useEffect, useState } from 'react';
import { Save, Check } from 'lucide-react';
import { api } from '../../lib/api';

export default function GeneralSettings() {
  const [cfg, setCfg] = useState({
    leads_to_email: '',
    auto_reply_enabled: true,
    auto_reply_subject: { es: '', en: '' },
    auto_reply_body: { es: '', en: '' },
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/admin/settings/general')
      .then(({ data }) => setCfg({ ...cfg, ...(data?.value || {}) }))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/settings/general', { value: cfg });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-ink-muted py-20 text-center">Cargando…</div>;

  return (
    <div data-testid="general-settings">
      <div className="flex items-center justify-between mb-8 pb-6 border-b border-line">
        <div>
          <p className="text-eyebrow text-ink-muted mb-2">Configuración</p>
          <h1 className="font-display text-4xl md:text-5xl text-ink">General</h1>
        </div>
        <button onClick={save} disabled={saving} className="btn-acid !px-6 !py-2.5 !text-[11px]" data-testid="general-save">
          <Save size={13} /> {saving ? 'Guardando…' : 'Guardar'}
        </button>
      </div>

      {saved && (
        <div className="mb-6 px-4 py-3 bg-acid/10 border border-acid/40 text-acid rounded-md text-sm font-mono flex items-center gap-2">
          <Check size={14} /> Guardado.
        </div>
      )}

      <div className="space-y-6 bg-bg-secondary border border-line rounded-md p-6 md:p-8">
        <div>
          <label className="text-eyebrow mb-1 block">Email donde recibir leads</label>
          <input
            type="email"
            value={cfg.leads_to_email || ''}
            onChange={(e) => setCfg({ ...cfg, leads_to_email: e.target.value })}
            className="input-bare"
            placeholder="contacto@empresa.com"
            data-testid="leads-to-email"
          />
        </div>

        <label className="flex items-center justify-between bg-bg border border-line rounded-md px-4 py-3 cursor-pointer">
          <span className="text-sm text-ink font-mono">Auto-respuesta al usuario</span>
          <input
            type="checkbox"
            checked={!!cfg.auto_reply_enabled}
            onChange={(e) => setCfg({ ...cfg, auto_reply_enabled: e.target.checked })}
            className="w-5 h-5 accent-acid"
            data-testid="auto-reply-enabled"
          />
        </label>

        <div>
          <label className="text-eyebrow mb-2 block">Asunto auto-respuesta (ES / EN)</label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="input-bare" placeholder="Hemos recibido…" value={cfg.auto_reply_subject?.es || ''} onChange={(e) => setCfg({ ...cfg, auto_reply_subject: { ...(cfg.auto_reply_subject || {}), es: e.target.value } })} data-testid="auto-reply-subject-es" />
            <input className="input-bare" placeholder="We received…"     value={cfg.auto_reply_subject?.en || ''} onChange={(e) => setCfg({ ...cfg, auto_reply_subject: { ...(cfg.auto_reply_subject || {}), en: e.target.value } })} data-testid="auto-reply-subject-en" />
          </div>
        </div>

        <div>
          <label className="text-eyebrow mb-2 block">Cuerpo auto-respuesta (ES / EN)</label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <textarea rows={4} className="input-bare resize-none" placeholder="Gracias por contactar…" value={cfg.auto_reply_body?.es || ''} onChange={(e) => setCfg({ ...cfg, auto_reply_body: { ...(cfg.auto_reply_body || {}), es: e.target.value } })} data-testid="auto-reply-body-es" />
            <textarea rows={4} className="input-bare resize-none" placeholder="Thanks for reaching out…" value={cfg.auto_reply_body?.en || ''} onChange={(e) => setCfg({ ...cfg, auto_reply_body: { ...(cfg.auto_reply_body || {}), en: e.target.value } })} data-testid="auto-reply-body-en" />
          </div>
        </div>
      </div>
    </div>
  );
}
